const getNumberOfActiveFilters = (
  shallowSearchParams: URLSearchParams,
  facetType?: string,
) => {
  const relevantSearchParams = shallowSearchParams
    ?.toString()
    ?.split('&')
    ?.filter((param) => {
      if (!param?.length || param.includes('sort=') || param.includes('query='))
        return false;

      return facetType ? param.includes(facetType) : true;
    });

  const numberOfActiveFilters = relevantSearchParams?.reduce((acc, param) => {
    return acc + decodeURIComponent(param?.toString())?.split(',')?.length || 0;
  }, 0);
  return numberOfActiveFilters;
};

export default getNumberOfActiveFilters;
